import { useEffect, useMemo, useState } from 'react';
import { hrApi } from '@/api/hr.api';
import { SearchableSelect } from '@/components/ui/SearchableSelect';
import type { SelectOption } from '@/components/ui/Select';
import type { HrShift } from '@/types/hr';
import { showApiError } from '@/utils/apiError';

export function HrShiftSelect({
  label = 'Shift',
  value = '',
  onChange,
  placeholder = 'Select shift',
  className,
  required,
}: {
  label?: string;
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  className?: string;
  required?: boolean;
}) {
  const [shifts, setShifts] = useState<HrShift[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    hrApi
      .listShifts()
      .then(setShifts)
      .catch((err) => showApiError(err, 'Failed to load shifts'))
      .finally(() => setLoading(false));
  }, []);

  const options: SelectOption[] = useMemo(
    () =>
      shifts.map((shift) => ({
        value: String(shift.id),
        label: shift.startTime && shift.endTime
          ? `${shift.name} (${shift.startTime}–${shift.endTime})`
          : shift.name,
      })),
    [shifts],
  );

  return (
    <SearchableSelect
      className={className}
      label={label}
      required={required}
      value={value}
      onChange={onChange}
      options={options}
      placeholder={placeholder}
      loading={loading}
      searchPlaceholder="Search shifts…"
      emptyMessage="No shifts found"
    />
  );
}
